<template>
  <div>
    <section id="hero">
      <v-img
        :min-height="minHeight"
        :src="require('@/assets/homepage/home-hero.jpg')"
        class="white--text"
        gradient="to right, rgba(63, 47, 0, .8), rgba(63, 47, 0, .8)"
      >
        <v-container class="fill-height px-4 py-12">
          <v-responsive
            class="d-flex align-center"
            height="100%"
            max-width="900"
            width="100%"
          >
            <h1 class="text-h5 text-sm-h4 text-md-h3 text-l-h1 text-xl-h1 font-weight-black mb-4 text-left white--text text-uppercase">
              Safe and effective tutorials during Covid 19
            </h1>
            
            <p class="text-body-1 text-sm-body-1 text-md-h5 text-l-h3 text-xl-h3 grey--text text--lighten-3 text-left mb-10">
              Observe, prompt and assist students who are working on your tutorials, whether they're in the room with you or working remotely.
            </p>

            <div class="d-flex flex-wrap">
              <v-dialog max-width="600px" v-model="dialogVisible">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="primary" depressed large v-bind="attrs" v-on="on">
                    Create a lecturer account
                  </v-btn>
                </template>
                <AuthOptions userType="LECTURER" redirectRouteName="Welcome" />
              </v-dialog>

              <v-btn large text color="white" class="ml-3" href="https://www.youtube.com/watch?v=d_ClW-4sx3E" target="_BLANK">
                Or watch the demo<v-icon>open_in_new</v-icon>
              </v-btn>
            </div>
          </v-responsive>
        </v-container>
      </v-img>
    </section>

    <section id="features" class="mt-10">
      <h1 class="text-uppercase text-h5 font-weight-bold mb-2 text-center">
        Features
      </h1>
      <v-row>
        <v-col cols="1" class="mx-auto">
          <v-divider></v-divider>
        </v-col>
      </v-row>

      <v-container>
        <v-row class="mb-6">
          <v-col sm="2" class="d-none d-sm-flex">
            <v-avatar size="84" class="grey lighten-3" style="opacity: 0.7">
              <v-avatar size="72" class="white">
                <v-icon x-large>visibility</v-icon>
              </v-avatar>
            </v-avatar>
          </v-col>
          <v-col sm="10" cols="12">
            <h3 class="text-uppercase text-h6 font-weight-bold mp-3">
              Observe student progress
            </h3>
            <p class="text-body-1 mx-auto grey--text text--darken-2">
              View the progress of students as they work in a tutorial. See who's falling behind or racing ahead, who's asking for help and who isn't asking but needs help.
            </p>
          </v-col>
        </v-row>

        <v-row class="mb-6">
          <v-col sm="2" class="d-none d-sm-flex">
            <v-avatar size="84" class="grey lighten-3" style="opacity: 0.7">
              <v-avatar size="72" class="white">
                <v-icon x-large>hearing</v-icon>
              </v-avatar>
            </v-avatar>
          </v-col>
          <v-col sm="10" cols="12">
            <h3 class="text-uppercase text-h6 font-weight-bold mp-3">
              Assist students who need help
            </h3>
            <p class="text-body-1 mx-auto grey--text text--darken-2">
              Respond to students who ask for help by triggering a one-to-one screenshare and video call.
            </p>
          </v-col>
        </v-row>


        <v-row class="mb-6">
          <v-col sm="2" class="d-none d-sm-flex">
            <v-avatar size="84" class="grey lighten-3" style="opacity: 0.7">
              <v-avatar size="72" class="white">
                <v-icon x-large>message</v-icon>
              </v-avatar>
            </v-avatar>
          </v-col>
          <v-col sm="10" cols="12">
            <h3 class="text-uppercase text-h6 font-weight-bold mp-3">
              Prompt students who are stuck
            </h3>
            <p class="text-body-1 mx-auto grey--text text--darken-2">
              Trigger a one-to-one or group screenshare and video call with students who are stuck at a particular part of the tutorial.
            </p>
          </v-col>
        </v-row>

      </v-container>
    </section>
  </div>
</template>

<script>
import AuthOptions from '@/components/auth/AuthOptions'

export default {
  name: 'Home',
  components: { AuthOptions },
  computed: {
    minHeight () {
      const height = this.$vuetify.breakpoint.mdAndUp ? '100vh' : '50vh'

      return `calc(${height} - ${this.$vuetify.application.top}px)`
    },
    dialogVisible: {
      get() {
        return this.$store.getters.dialogVisible
      },
      set(value) {
        this.$store.dispatch('setDialogVisibility', value)
      }
    }
  },
}
</script>

<style scoped>

</style>